import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div className="min-h-[70vh] grid place-items-center px-6" data-testid="payment-cancel-page">
      <div className="eyw-card p-10 max-w-md w-full text-center">
        <XCircle size={48} className="text-[#D98E73] mx-auto mb-4" />
        <h1 className="font-serif text-3xl text-[#1A242B]">Payment cancelled</h1>
        <p className="text-[#4A5D6B] mt-3">No charge was made. You can pick up where you left off anytime.</p>
        <div className="flex gap-3 justify-center mt-7">
          <Link to="/wellness" className="eyw-btn">Wellness Services</Link>
          <Link to="/events" className="eyw-btn-ghost">Events</Link>
        </div>
      </div>
    </div>
  );
}
